import { render, staticRenderFns } from "./header.vue?vue&type=template&id=04cfccc0&scoped=true&"
var script = {}
import style0 from "./header.vue?vue&type=style&index=0&id=04cfccc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cfccc0",
  null
  
)

export default component.exports